import { EventContentArg } from "@fullcalendar/core";
import { Box } from "@mui/material";

interface Props {
  eventInfo: EventContentArg;
}

export const WorkOrderStateChip = (props: Props) => {
  const { eventInfo } = props;
  const workOrderStateName =
    eventInfo.event.extendedProps["workOrderStateName"];

  return workOrderStateName ? (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1,
        py: 0.25,
        bgcolor: "#eaf5ff",
        color: "#0b3c6f",
        borderRadius: "4px",
        fontWeight: 600,
        fontSize: "0.75rem",
        marginBottom: "4px",
      }}
    >
      {workOrderStateName}
    </Box>
  ) : null;
};
